import { store } from "@/store";
import Debugger from "../console/debugger";
import EventBus from "../event_bus";
import DEFINE from "../painter/define";
import PainterProxy from "../painter/proxy";
import { TOOLS } from "./tools";
import AppRenderer from "../../js/app_renderer";
import BookData from "../../js/book_data";

export default class MathTool {

    _summaryGraph = null;

    _ruler = null;

    constructor(summaryGraph) {
        this._summaryGraph = summaryGraph;
    }

    getToolFunction() {
        return [
            {
                key: "compasses",
                event: this.useCompass()
            },
            {
                key: "protractor",
                event: this.useProtractor()
            },
            {
                key: "ruler",
                event: this.useRuler()
            },
            {
                key: "isosceles_triangle",
                event: this.useIsoscelesTriangle()
            },
            {
                key: "right_triangle",
                event: this.useRightTriangle()
            },
            {
                key: "angle_polygon",
                event: this.openPolygonCreater()
            },
            {
                //計算機
                key: "computer",
                event: () => {
                    AppRenderer.Instance.openWebSite("https://digitalmaster.knsh.com.tw/ju/math/calculator/test_css.html");
                }
            },
            {
                //統計圖
                key: "summary_graph",
                event: () => {
                    this._summaryGraph.show = true;
                }
            }
        ]
    }

    useCompass() {
        Debugger.Instance.log("compasses", "math_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.COMPASS, {}, () => {
                proxy.changeTool(null);
                store.setPreviousTool(TOOLS.SELECTION.TOOL)
                store.nowTool = TOOLS.SELECTION.TOOL;
            });
        }
    }

    useProtractor() {
        Debugger.Instance.log("protractor", "math_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.PROTRACTOR, {}, () => {
                proxy.changeTool(null);
                store.setPreviousTool(TOOLS.SELECTION.TOOL)
                store.nowTool = TOOLS.SELECTION.TOOL;
            });
        }
    }

    useRuler() {
        Debugger.Instance.log("ruler", "math_tool");
        const proxy = PainterProxy.getInstance();
        const ruler = EventBus.getInstance()._bookPage.$refs.ruler;

        return () => {
            ruler.switchRuler(true);
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(null);
            store.setPreviousTool(TOOLS.SELECTION.TOOL)
            store.nowTool = TOOLS.SELECTION.TOOL;
        }
    }

    useIsoscelesTriangle() {
        Debugger.Instance.log("isosceles_triangle", "math_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.ISOSCELES_TRIANGLE, {}, () => {
                proxy.changeTool(null);
                store.setPreviousTool(TOOLS.SELECTION.TOOL)
                store.nowTool = TOOLS.SELECTION.TOOL;
            });
        }
    }

    useRightTriangle() {
        Debugger.Instance.log("right_triangle", "math_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.RIGHT_TRIANGLE, {}, () => {
                proxy.changeTool(null);
                store.setPreviousTool(TOOLS.SELECTION.TOOL)
                store.nowTool = TOOLS.SELECTION.TOOL;
            });
        }
    }

    openPolygonCreater() {
        Debugger.Instance.log("angle_polygon", "math_tool");
        const proxy = PainterProxy.getInstance();
        const polygonCreater = EventBus.getInstance().getAppRefs().polygonCreater;

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            store.setPreviousTool(TOOLS.SELECTION.TOOL)
            polygonCreater.show = true;
        }
    }
}